var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_573_68201)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9018,
    cy: 11.2982,
    rx: 10.5737,
    ry: 10.6263,
    fill: "black",
    fillOpacity: 0.52
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55387 7.16602C7.9047 7.16602 7.37891 7.69443 7.37891 8.34683V14.2509C7.37891 14.9033 7.9047 15.4317 8.55387 15.4317C9.20303 15.4317 9.72883 14.9033 9.72883 14.2509V8.34683C9.72883 7.69443 9.20303 7.16602 8.55387 7.16602ZM13.2537 7.16602C12.6045 7.16602 12.0787 7.69443 12.0787 8.34683V14.2509C12.0787 14.9033 12.6045 15.4317 13.2537 15.4317C13.9029 15.4317 14.4287 14.9033 14.4287 14.2509V8.34683C14.4287 7.69443 13.9029 7.16602 13.2537 7.16602Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_573_68201",
    x: -29.6691,
    y: -29.3253,
    width: 81.1429,
    height: 81.2469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.9986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_573_68201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_573_68201",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPause);
export default __webpack_public_path__ + "static/media/Video_pause.54c9da8d8d27daf3b643800c0a30be06.svg";
export { ForwardRef as ReactComponent };